import { Grid } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { clientConfigSetup } from '../../clientConfigsSetup';
import ContractCard from '../ContractCard';
import ContractsListStyle from './ContractsListStyle';
import { TenantFeatureFlag } from 'features/saasManagement/TenantConfig/TenantFeatureFlag';

const useStyles = ContractsListStyle;

const ContractsList = ({ clientId, clientAccountId, clientsWithConfigs }) => {

    const classes = useStyles();

    const [clientConfig, setClientConfig] = useState()

    useEffect(() => {
        if (clientId && clientsWithConfigs) {
            let a = clientsWithConfigs.find(c => c.id == clientId && (clientAccountId ? c.accountId == clientAccountId : true))
            setClientConfig(a)
        }
    }, [clientId, clientsWithConfigs])

    const allContracts = clientConfigSetup();

    return (
        <>
            {clientConfig &&
                <div>
                    <div className={classes.title}>Select type of SLA</div>
                    <Grid container>
                        {allContracts.map((contract, index) =>
                            <TenantFeatureFlag featureFlagName={contract.featureFlagName}>
                                <Grid key={index} item xs={6}>
                                    <ContractCard contract={contract} clientConfig={clientConfig} setClientConfig={setClientConfig} />
                                </Grid>
                            </TenantFeatureFlag>
                        )}
                    </Grid>
                </div>
            }
        </>
    );
};

export default ContractsList;


